import { callAPI } from "features/yard360/store/helpers/apiCaller";
import { APIS } from "app/app-config";
import {
  FETCH_FEATURE_FLAGS,
  FETCH_FEATURE_FLAGS_SUCCESS,
  FETCH_FEATURE_FLAGS_FAILURE,
} from "features/yard360/store/featureFlags/types";

/**
 * Fetches the whole feature-flag set in a SINGLE IsFeatureEnabled call
 * (request.features / response.features — the batch shape in
 * YTYardConsoleServiceModel; the single-feature attribute is deprecated).
 *
 * @param {string[]} features flag keys to query
 */
export const fetchAllFeatureFlags = (features) => {
  return async (dispatch, getState) => {
    dispatch(fetchFeatureFlagsRequest(features));

    try {
      const { activeBuildingCode } = getState().authInfo;
      const response = await callAPI(getState().authInfo, APIS.IsFeatureEnabled, {
        features,
        ...(activeBuildingCode && { yardId: { buildingCode: activeBuildingCode } }),
      });

      dispatch(fetchFeatureFlagsSuccess(response?.features ?? []));
    } catch (e) {
      dispatch(fetchFeatureFlagsFailure(features, e.message));
    }
  };
};

export const fetchFeatureFlagsRequest = (features) => {
  return {
    type: FETCH_FEATURE_FLAGS,
    payload: { features },
  };
};

/**
 * @param {Array<{ feature: string, enabled: boolean }>} features enablement states
 */
export const fetchFeatureFlagsSuccess = (features) => {
  return {
    type: FETCH_FEATURE_FLAGS_SUCCESS,
    payload: { features },
  };
};

export const fetchFeatureFlagsFailure = (features, errorMessage) => {
  return {
    type: FETCH_FEATURE_FLAGS_FAILURE,
    payload: { features, errorMessage },
  };
};
